export enum EPageTemplate {
  ErrorPage = 'ERROR_PAGE',
  Page = 'PAGE',
  Contact = 'CONTACT'
}
